import _ from 'lodash'
import camelCaseKeys from 'utils/camelCase'

export default function ApiError(message, response, content) {
  this.name = 'ApiError'
  this.message = message
  this.stack = new Error(message).stack
  this.response = response
  this.content = content
}
ApiError.prototype = Object.create(Error.prototype)
ApiError.prototype.constructor = ApiError

export const getJsonContent = (response) =>
  response.json().then((content) => {
    const camelCased = camelCaseKeys(content, { deep: true })
    camelCased._raw = content
    return camelCased
  })
// Throw errors depending on problem for logging and debugging purposes
// Maybe for routing purposes in the future? Like routing to an error page
// if we can't communicate with the API at all?
// Made to be run in a promise chain for isomorphic fetch so return argument by default
export const handleApiResponse = (response) => {
  const contentType = response.headers.get('Content-Type')
  let parseMethod = null

  if (_.includes(contentType, 'json')) {
    parseMethod = 'json'
  }

  if (_.includes(contentType, 'text')) {
    parseMethod = 'text'
  }

  // Always parse the response to text or json, this is not ideal since this
  // action is "destructive". We do this because some endpoints return
  // status 200 with json { status: 'ERROR' }
  return Promise.resolve()
    .then(() => {
      if (response.status === 204) {
        return ''
      }

      switch (parseMethod) {
        case 'text':
          return response.text()
        case 'json':
          return getJsonContent(response)
        default:
          return ''
      }
    })
    .then((textOrJson) => {
      if (
        !response.ok || // Status is not 200-299
        (parseMethod === 'json' && textOrJson.status === 'ERROR') ||
        (parseMethod === 'json' && _.get(textOrJson, 'apiError.status') === 'TRANS_ERROR')
      ) {
        const error = new Error(`${response.status} ${response.statusText} ${response.url}`)
        error.content = textOrJson
        error.response = _.pick(response, ['status', 'statusText', 'ok', 'type'])
        throw error
      }

      return {
        ..._.pick(response, ['status', 'statusText', 'ok', 'type']),
        ...textOrJson,
        textOrJson,
      }
    })
}
